import Customs from "../Assets/maps/customs.jpg";
import Factory from "../Assets/maps/factory.jpg";
import Factory1 from "../Assets/maps/factory1.jpg";
import Reserve from "../Assets/maps/reserve.jpg";
import Lighthouse from "../Assets/maps/lighthouse.jpg";
import Shoreline from "../Assets/maps/shoreline.jpg";
import Woods from "../Assets/maps/woods.jpg";
import Interchange from "../Assets/maps/interchange.jpg";
import Labs from "../Assets/maps/labs.jpg";
import Streets from "../Assets/maps/streets.jpg";
import GroundZero from "../Assets/maps/groundzero.jpg";

export const AllMaps = [
  {
    name: "Customs",
    img: Customs,
  },
  {
    name: "Factory",
    img: Factory1,
  },
  {
    name: "Night Factory",
    img: Factory,
  },
  {
    name: "Reserve",
    img: Reserve,
  },
  {
    name: "Lighthouse",
    img: Lighthouse,
  },
  {
    name: "Shoreline",
    img: Shoreline,
  },
  {
    name: "Woods",
    img: Woods,
  },
  {
    name: "Interchange",
    img: Interchange,
  },
  {
    name: "The Lab",
    img: Labs,
  },
  {
    name: "Streets of Tarkov",
    img: Streets,
  },
  {
    name: "Ground Zero",
    img: GroundZero,
  },
];
